import { useMemo } from "react";
import Avatar from "../Avatar";
import { FragenWahl, ZeitWahl } from "../Auswahl";
import Button from "../Button";
import Icon from "../icons/Icon";
import Sheet from "../Sheet";
import StatusChip from "../StatusChip";
import TextFeld from "../TextFeld";
import { farbNummern } from "../../spieler";
import "./EinstellungenDialog.css";

/** Einstellungen mitten im Spiel (Host). Code & QR stehen im Menue. */
export function EinstellungenDialog({
  spotifyStatus,
  onOpenDevices,
  timeLimit,
  setTimeLimit,
  activeTasks,
  setActiveTasks,
  players,
  setPlayers,
  gameMode,
  onAddPlayer,
  onLogout,
  onClose,
}) {
  const name = (p, i) => p.name.trim() || `Spieler ${i + 1}`;
  const namenSchluessel = players.map(name).join("\n");
  const farbe = useMemo(() => farbNummern(namenSchluessel.split("\n")), [namenSchluessel]);
  const buzzer = gameMode === "BUZZER";

  return (
    <Sheet
      titel="Einstellungen"
      mitX
      onClose={onClose}
      fuss={
        <>
          <Button variant="haupt" onClick={onClose}>
            Fertig
          </Button>
          <Button variant="text" className="einstellungen-abmelden" onClick={onLogout}>
            <Icon name="tuer" />
            Spotify-Konto abmelden
          </Button>
          <p className="sheet-hinweis einstellungen-fuss">
            Bei der Neuanmeldung kommt die Konto-Auswahl. Punkte und Verlauf gehen dabei verloren.
          </p>
        </>
      }
    >
      {/* Der Status IST der Weg zur Geraeteauswahl */}
      <button type="button" className="zeile-knopf" onClick={onOpenDevices}>
        <Icon name="lautsprecher" />
        Spotify
        <span className="zeile-rechts">
          <StatusChip art="spotify" status={spotifyStatus} />
          <Icon name="pfeil" size={18} />
        </span>
      </button>

      <section className="abschnitt">
        <h2>Zeit pro Song</h2>
        <ZeitWahl wert={timeLimit} onChange={setTimeLimit} />
      </section>

      <section className="abschnitt">
        <h2>Was wird gefragt?</h2>
        <FragenWahl activeTasks={activeTasks} setActiveTasks={setActiveTasks} />
      </section>

      <section className="abschnitt">
        <div className="abschnitt-titel">
          <h2 className="einstellungen-h2">Spieler</h2>
          <span>{buzzer ? "kommen über den Raumcode dazu" : "Punkte"}</span>
        </div>
        {players.map((p, i) => (
          <div key={i} className="spieler-zeile">
            <Avatar name={name(p, i)} farbe={farbe(name(p, i))} />
            <TextFeld
              className="klein"
              value={p.name}
              placeholder={`Spieler ${i + 1}`}
              aria-label={`Name Spieler ${i + 1}`}
              // Im Buzzer-Modus fuehrt der Raum die Liste: Namen kommen von
              // den Handys, ein Tippen hier wurde beim naechsten Abgleich
              // stillschweigend ueberschrieben.
              readOnly={buzzer}
              onChange={(e) =>
                setPlayers((prev) => prev.map((pl, idx) => (idx === i ? { ...pl, name: e.target.value.slice(0, 20) } : pl)))
              }
            />
            <span className="spieler-stand">{p.score}</span>
          </div>
        ))}
        {!buzzer && (
          <button type="button" className="neu-zeile" onClick={onAddPlayer}>
            <Icon name="plus" />
            Spieler hinzufügen
          </button>
        )}
      </section>
    </Sheet>
  );
}

export default EinstellungenDialog;
